export default __webpack_public_path__ + "static/media/carousel8.cb123508.png";